import {
  EDIT_CABIN,
  EDIT_CHANGEFARE,
  GET_CHANGE_COST,
  INIT_FLIGHT,
  GET_PRODUCTSHOW_LIST,
} from './actions';

const initialState = {
  epidemicDisease: '', // 0126 新冠疫情 0522 广州疫情
  epidemicPolicy: {},
  selectNum: -1, // -1 为当前选择舱位，> -1 为推荐升舱里面的舱位， 具体数据按序列读取
  changeCost: {}, // 当前所选的舱位信息
  recommended: [], // 推荐升舱
  shopList: [],
};

export default function changeFlightReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_FLIGHT:
      return initialState;
    case `${GET_CHANGE_COST}_SUCCESS`:
      const {
        payload: {
          data: {
            recommended,
            selected,
            // isSpecialDateFree,
            remark,
            charge,
            difcost,
          },
        },
      } = action;
      return Object.assign({}, state, {
        recommended: recommended || [],
        changeCost: selected,
        // epidemicDisease: isSpecialDateFree ? isSpecialDateFree : '',
        epidemicPolicy: {
          remark, // 疫情原因标识
          charge, // 手续费比例
          difcost, // 票价差比例
        },
      });
    case EDIT_CABIN:
      return Object.assign({}, state, { selectNum: action.n });
    case EDIT_CHANGEFARE:
      const arr = [...state.recommended];
      const obj =
        state.selectNum === -1 ? state.changeCost : arr[state.selectNum];
      const psgCosts = obj.psgCosts.map(item => {
        const fee = action.data.filter(
          child => item.psgType === child.psgType
        )[0];
        return Object.assign({}, item, {
          exchangeCost: String(fee.exchangeCost),
          exchangeFee: String(Number(fee.exchangeCost) / item.psgCount),
          psgCost: String(Number(item.priceCost) + Number(fee.exchangeCost)),
        });
      });
      const cc = Object.assign({}, obj, {
        psgCosts,
        totalCost: psgCosts.reduce(
          (a, b) =>
            Number(a.exchangeCost) +
            Number(a.priceCost) +
            Number(b.exchangeCost) +
            Number(b.priceCost),
          {
            exchangeCost: 0,
            priceCost: 0,
          }
        ),
      });
      if (state.selectNum === -1) {
        return Object.assign({}, state, { changeCost: cc });
      } else {
        arr.splice(state.selectNum, 1, cc);
        return Object.assign({}, state, {
          recommended: arr,
        });
      }
    case `${GET_PRODUCTSHOW_LIST}_SUCCESS`:
      const {
        payload: { data },
      } = action;
      return Object.assign({}, state, {
        shopList: data.data,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/changeFlight/modules/changeFlight.js